// 50 50 column layout
import React, { useContext, useEffect, useRef } from 'react';
import { useTheme } from '@emotion/react';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import { RefsContext } from '@bbkFunnelUtils/refs.context';
import CustomerHtml from '../customer_html/customer_html';

type Props = {
  quote: React.ReactNode;
  title: React.ReactNode;
  detailedAction: React.ReactNode;
};
const FiftyFiftyColumn: React.FC<Props> = (props) => {
  const theme = useTheme() as EmotionTheme;
  const { quote, title, detailedAction } = props;

  const refsPrefix = '123'; // FIXME
  const refsContext = useContext(RefsContext);
  const titleRef = useRef<HTMLSpanElement>(null);
  useEffect(() => refsContext?.addRef(`${refsPrefix}`, titleRef), [titleRef]);

  return (
    <div className="fifty-fifty-column">
      <div className="ffContainer">
        <div className="left" style={{ backgroundColor: theme.primaryColor }}>
          {quote}
        </div>
        <div className="right">
          <span ref={titleRef}>
            <CustomerHtml value={title} />
          </span>
          {detailedAction}
        </div>
      </div>
    </div>
  );
};

export default FiftyFiftyColumn;
